var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/excalidraw.ts
import "@adornis/base/utilTypes.js";
import { constructValue } from "@adornis/baseql/entities/construct.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import "@adornis/excalidraw/client/x-excalidraw.js";
import { ExcalidrawData } from "@adornis/excalidraw/db/ExcalidrawData.js";
import "@adornis/forms/x-input";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { HTMLBaseExcalidraw } from "../../db/HTMLBaseExcalidraw.js";
import { EXCALIDRAW_KEY, EXCALIDRAW_SCHEMA } from "../../schema/nodes/excalidraw.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection, updateNodeAttrs } from "../util.js";
var excalidraw = () => ({
  node: {
    name: EXCALIDRAW_KEY,
    schema: EXCALIDRAW_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.MEDIA,
      label: "Excalidraw",
      icon: "brush",
      run: (view) => runInsertNode(EXCALIDRAW_KEY)(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    },
    {
      label: "Excalidraw editieren",
      icon: "brush",
      run: async (view) => {
        if (!isNodeSelection(view.state.selection))
          return;
        let data = constructValue(JSON.parse(view.state.selection.node.attrs.data));
        if (!data)
          data = new HTMLBaseExcalidraw({});
        return EditExcalidrawDialog.showPopup({
          props: {
            data
          }
        }).then((res) => {
          if (!(res instanceof HTMLBaseExcalidraw))
            return;
          view.dispatch(
            updateNodeAttrs(view.state, view.state.tr, () => view.state.selection.from, {
              data: JSON.stringify(res.toObject())
            })
          );
        });
      },
      shouldVisualize: (view) => {
        return isNodeSelection(view.state.selection) && view.state.selection.node.type.name === EXCALIDRAW_KEY;
      }
    },
    {
      label: "Excalidraw aus der Zwischenablage einf\xFCgen",
      icon: "content_paste",
      run: async (view) => {
        return navigator.clipboard.readText().then((res) => {
          const data = JSON.parse(res.replaceAll("\\", "\\\\"));
          if (!data)
            return;
          const constructedData = new HTMLBaseExcalidraw({
            data: new ExcalidrawData({
              content: res,
              binaryFiles: "{}"
            })
          });
          view.dispatch(
            updateNodeAttrs(view.state, view.state.tr, () => view.state.selection.from, {
              data: JSON.stringify(constructedData.toObject())
            })
          );
        });
      },
      shouldVisualize: (view) => {
        return isNodeSelection(view.state.selection) && view.state.selection.node.type.name === EXCALIDRAW_KEY;
      }
    }
  ]
});
var NodeExcalidraw = class extends BuildifyLitElement {
  content({ content, mode }) {
    const height = content?.height || "500px";
    return content ? html`
          <x-excalidraw
            ${css({
      width: "100%",
      height,
      boxSizing: "border-box"
    })}
            .mode=${"view"}
            .height=${height}
            .value=${content?.data}
          ></x-excalidraw>
        ` : html`
          <x-flex
            center
            crossaxis-center
            ${css({
      width: "100%",
      height,
      boxSizing: "border-box"
    })}
          >
            EXCALIDRAW
          </x-flex>
        `;
  }
};
NodeExcalidraw = __decorateClass([
  customElement("node-excalidraw")
], NodeExcalidraw);
var EditExcalidrawDialog = class extends XNativeDialog {
  static get element_name() {
    return "edit-excalidraw-dialog";
  }
  content() {
    const content = this.data;
    if (!content)
      return nothing;
    const height = content.height || "500px";
    return html`
      <x-excalidraw
        ${css({
      width: "100%",
      height,
      boxSizing: "border-box"
    })}
        .mode=${"edit"}
        .height=${height}
        .value=${content.data}
        @value-changed=${(e) => {
      if (!content)
        return;
      content.data = e.detail.value;
    }}
      ></x-excalidraw>
      <x-flex horizontal crossaxis-center space-between wrap space="md">
        <x-button
          mode="outline"
          @click=${() => {
      this.close(void 0);
    }}
        >
          Abbrechen
        </x-button>
        <x-button
          @click=${() => {
      this.close(content);
    }}
        >
          Speichern
        </x-button>
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        dialog: {
          width: "min(1400px, 95%)",
          overflow: "hidden",
          padding: "8px"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], EditExcalidrawDialog.prototype, "data", 2);
EditExcalidrawDialog = __decorateClass([
  customElement("edit-excalidraw-dialog")
], EditExcalidrawDialog);
export {
  EditExcalidrawDialog,
  NodeExcalidraw,
  excalidraw
};
